<template lang="html">

  <div class="main-content">

    <breadcrumb :nameSection = 'nameSection' :listRoutes = 'listRoutes'></breadcrumb>

    <div class="form-content">

      <div class="form-content-title">

        <div class="form-content-title-block form-title">

            <div class="form-title-block form-title-principal">

              <span>Embarques</span>

            </div>

            <div class="form-title-block">

              <router-link v-if="$store.state.user.attributes.permissions_keys.includes(15)" class="btn btn-primary" :to="{ name: 'shipments-create'}">Nuevo Embarque</router-link>

            </div>

        </div>

        <div class="form-content-title-block filter-container">

          <div class="filter-block filter-block-various">

            <label>Buscar por</label>

            <div class="filter-block-content">

              <select
                  id="select-search"
                  class="form-control"
                  v-model="tableData.filterBy"
                  @change="cleanInput()"
                >
                  <option value="all">Todos</option>
                  <option
                    :value="option.name"
                    v-for="(option) in filterColumns"
                    :key="option.id"
                  >{{option.label}}</option>
                </select>

                <input
                id="search-bar"
                type="search"
                class="form-control"
                v-model="tableData.filterValue"
                placeholder="Buscar..."
                @keyup="getBoardings()"
              >

            </div>

          </div>

          <div class="filter-block filter-block-alone filter-block-ship">

            <label>Estado:</label>

            <div class="filter-block-content">

              <select class="form-control" v-model="tableData.status" @change="getBoardings()">
                <option
                    :value="index"
                    v-for="(option,index) in statusGroupArray"
                    :key="index"
                  >{{statusGroupArray[index]}}</option>
              </select>

            </div>

          </div>

        </div>

      </div>

      <!--<circle-spin v-if="is_loading"></circle-spin>-->

      <div class="table-ship">

        <data-table :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy" v-if="is_loading == false">
          <tbody v-if="boardings!=null && boardings.length > 0">
            <tr

              v-for="(boarding) in boardings"
              :key="boarding.id"
              @click="toEditShipmentView(boarding.id, boarding.attributes.status)"
            >

              <td>

                <span>{{boarding.id}}</span>

              </td>

              <td>
                <div class="ruta-order-container">
                    <div class="ruta-order-block ruta-order-image">
                      <img src="/static/img/ruta.svg" alt="">
                    </div>
                    <div class="ruta-order-block ">
                        <div class="ruta-order-content">
                          <span>{{boarding.attributes.origin.attributes.name}}</span>
                        </div>
                        <div class="ruta-order-content">
                          <span>{{boarding.attributes.destination.attributes.name}}</span>
                        </div>

                      </div>

                  </div>

              </td>

              <td>

                <span>{{boarding.attributes.departure_date|spanishDateTime}}</span>

              </td>

              <td>

                <span>{{boarding.attributes.arrival_date|spanishDateTime}}</span>

              </td>

              <td>

                <span>

                  <div class="order-tag-container">

                    <span
                      class="order-tag order-init"
                      v-if="boarding.attributes.status >=1 && boarding.attributes.status <= 3"
                    >{{statusGroupArray[10]}}</span>

                    <span
                      class="order-tag order-process"
                      v-else-if="boarding.attributes.status >=5 && boarding.attributes.status <= 7"
                    >{{statusGroupArray[20]}}</span>

                    <span
                      class="order-tag order-cancel"
                      v-else-if="boarding.attributes.status == 4"
                    >{{statusGroupArray[30]}}</span>

                    <span
                      class="order-tag order-message"

                    >{{boardingStatusArray[boarding.attributes.status]}}</span>

                  </div>

                </span>

              </td>

              <td>

                <span>{{boarding.attributes.updated_at.date|spanishDateTime}}</span>

              </td>
               <td style="bpadding: 0;">
                 <div style="width:150px">
                   <span>Paquetes : {{boarding.attributes.packages_total}} </span><br>
                   <span>Ordenes : {{boarding.attributes.purchaseorder_total}} </span><br>
                   <span>Peso : {{boarding.attributes.boarding_weight}} Kg</span><br>
              </div>
              </td>

            </tr>

          </tbody>

          <tbody v-else>

            <div class="no-results">

              <h1>No se encontraron resultados</h1>

            </div>

          </tbody>

        </data-table>

      </div>

    </div>

    <pagination
        :pagination="pagination"
        @changePagination="getBoardings"
        v-if="is_loading == false"
      ></pagination>

  </div>

</template>

<script>
import breadcrumb from '@/components/prefab/structures/breadcrumb.vue'
import DataTable from './DataTable.vue'
import Pagination from './Pagination.vue'
import axios from 'axios'
export default {
  components: { DataTable, Pagination, breadcrumb },
  created() {
    if (this.purchaseOrders == null) {
      this.is_loading = true
    }
    this.getBoardings()
  },
  data() {
    let statusGroupArray = {
      1: 'Todos',
      10: 'Procesamiento en origen',
      20: 'Procesamiento en destino',
      30: 'Stand-by',
    }
    let boardingStatusArray = {
      1: 'En dirección origen',
      2: 'Camino a aeropuerto',
      3: 'Vuelo al destino en curso',
      4: 'Stand-by',
      5: 'En aeropuerto del destino',
      6: 'En evaluación',
      7: 'Evaluación finalizada',
    }

    let sortOrders = {}
    let columns = [
      { label: 'ID Embarque', name: 'id', visible: true },
      { label: 'Destino', name: 'destination', visible: true },
      { label: 'Fecha de salida', name: 'departure_date', visible: true },
      { label: 'Fecha de llegada', name: 'arrival_date', visible: true },
      { label: 'Estado', name: 'status', visible: true },
      {
        label: 'Última actualización',
        name: 'updated_at',
        visible: true,
      },
      { label: 'Detalles', name: 'detail', visible: true },
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })
    return {
      boardings: null,
      columns,
      statusGroupArray,
      boardingStatusArray,

      sortKey: 'updated_at',
      sortOrders: sortOrders,
      filterKey: '',
      tableData: {
        draw: 0,
        length: 10,
        status: 1,
        orderBy: 'updated_at',
        dir: 'desc',
        filterBy: 'all',
        filterValue: null, // no hay ningun valor por el cual filtrar
        page: 1,
      },
      pagination: {
        lastPage: '',
        currentPage: '',
        total: '',
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: '',
      },
      is_loading: true,

      nameSection: 'Embarques',
      listRoutes: [{ nameRoute: 'shipments-list', titleRoute: 'Embarques' }],
    }
  },
  methods: {
    getBoardings(page = 1) {
      console.log('getBoardings')
      this.is_loading = true
      this.tableData.draw++
      this.tableData.page = page

      let permissions = this.$store.state.user.attributes.permissions_keys
      let url
      if (permissions.includes(9)) {
        url = process.env.API_URL + '/api/boarding/list-all'
      } else if (permissions.includes(10)) {
        url =
          process.env.API_URL +
          '/api/boarding/' +
          this.$store.state.user.id +
          '/list-all-by-sender'
      } else if (permissions.includes(11)) {
        url =
          process.env.API_URL +
          '/api/boarding/' +
          this.$store.state.user.id +
          '/list-all-by-reciever'
      } else {
        alert('El usuario no tiene permisos para ver órdenes de compra')
        return
      }

      console.log('=======================')
      console.log('URL: ' + url)
      console.log('Datos de la tabla : ')
      console.log(this.tableData)
      console.log('=======================')

      // eslint-disable-next-line no-unreachable
      axios
        .get(url, { params: this.tableData })
        .then((response) => {
          let data = response.data
          console.log(data)

          // Condiciona si seleccionó una página diferente de la actual, juega con el table.data.draw++
          if (this.tableData.draw === data.meta.draw) {
            this.boardings = data.data
            this.configPagination(data)
            this.is_loading = false
          } else {
            console.log('out of sync')
            this.is_loading = false
          }
        })
        .catch((errors) => {
          console.log(errors.response)
          alert('No se obtuvieron resultados')
          this.is_loading = false
          return
        })
    },
    cleanInput() {
      this.tableData.filterValue = ''
    },
    configPagination(data) {
      this.pagination.lastPage = data.meta.last_page
      this.pagination.currentPage = data.meta.current_page
      this.pagination.total = data.meta.total
      this.pagination.lastPageUrl = data.links.last
      this.pagination.nextPageUrl = data.links.next
      this.pagination.prevPageUrl = data.links.prev
      this.pagination.from = data.meta.from
      this.pagination.to = data.meta.to
      this.pagination.perPage = this.tableData.length
    },
    sortBy(key) {
      console.log('entro al sort', key)
      this.sortKey = key
      this.sortOrders[key] = this.sortOrders[key] * -1
      this.tableData.orderBy = this.sortKey
      /* this.tableData.orderBy = this.getIndex(this.columns, 'name', key) */
      console.log(
        'tableData.orderBy',
        this.tableData.orderBy,
        'tableData.dir',
        this.tableData.dir,
        this.sortOrders[key]
      )
      this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc'
      console.log(
        'tableData.orderBy',
        this.tableData.orderBy,
        'tableData.dir',
        this.tableData.dir
      )
      this.getBoardings()
      console.log('paso la peticion api')
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] === value)
    },
    hideModal() {
      this.$refs.formmodal.hide()
    },
    toEditShipmentView(id, state) {
      console.log('Selected ID Embarque: ' + id + ', status: ' + state)
      if (
        state == 1 &&
        this.$store.state.user.attributes.permissions_keys.includes(19)
      ) {
        this.$router.push({
          name: 'shipments-edit',
          params: { idShipment: id },
        })
        return
      }

      if (
        state == 6 &&
        this.$store.state.user.attributes.permissions_keys.includes(18)
      ) {
        console.log('evaluate')

        this.$router.push({
          name: 'shipments-evaluate-package',
          params: { id: id },
        })
        return
      } else {
        this.$router.push({ name: 'shipments-show', params: { id: id } })
      }

      if (state != 1 && state != 6) {
        this.$router.push({ name: 'shipments-show', params: { id: id } })
      }
    },
  },
  computed: {
    filterColumns() {
      let activeFilterColumns = ['id', 'destination']
      return this.columns.filter(
        (i) => activeFilterColumns.indexOf(i.name) > -1
      )
    },
  },
}
</script>



// WEBPACK FOOTER //
// shipment-list-view.vue?54473d4a